var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-busena',{attrs:{"busena":_vm.prasymasBusena,"color":_vm.busenaColor}})}
var staticRenderFns = []

export { render, staticRenderFns }